/* eslint-disable no-console */
/*eslint no-undef: */
// import Vue from 'vue';
// import Router from 'vue-router';
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "./store";
import { updateVersion } from "@/plugins/index";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const staticRoutes = [
  {
    path: "/",
    meta: { auth: false },
    component: () => import("@/views/index"),
    children: [
      {
        path: "",
        meta: { auth: false },
        component: () => import("@/views/index/center"),
      },
      { path: "msgboard", component: () => import("@/views/msgboard") },
      {
        path: "tutorial",
        meta: { auth: false },
        component: () => import("@/views/index/tutorial"),
      },
      {
        path: "tool",
        meta: { auth: false },
        component: () => import("@/views/index/tool"),
      },
      { path: "project", component: () => import("@/views/index/project") },
      {
        path: "tool/:id",
        meta: { auth: false },
        component: () => import("@/views/index/tool/detail"),
      },
      {
        path: "tool/task/:id",
        component: () => import("@/views/index/tool/task"),
      },
      {
        path: "report/analyse",
        component: () => import("@/views/index/report/analyse"),
      },
      {
        path: "profile",
        meta: { auth: false },
        component: () => import("@/views/profile"),
        children: [
          {
            path: "summary",
            component: () => import("@/views/profile/summary"),
          },
          {
            path: "tool/fav",
            component: () => import("@/views/profile/tool/fav"),
          },
          {
            path: "tool/task",
            component: () => import("@/views/profile/tool/task"),
          },
          // { path: "file", component: () => import("@/views/profile/file") },
          {
            path: "msgboard",
            component: () => import("@/views/profile/msgboard"),
          },
          {
            path: "msgboard/:id",
            component: () => import("@/views/profile/msgboard/detail"),
          },
          {
            path: "message",
            component: () => import("@/views/profile/message"),
          },
          { path: "point", component: () => import("@/views/profile/point") },
          {
            path: "point/order",
            component: () => import("@/views/profile/point/order"),
          },
          { path: "order", component: () => import("@/views/profile/order") },
          {
            path: "point/order/success",
            component: () => import("@/views/profile/point/order/success"),
          },
          {
            path: "point/order/success/alipay",
            component: () =>
              import("@/views/profile/point/order/success-alipay"),
          },
          { path: "notice", component: () => import("@/views/profile/notice") },
          {
            path: "invoice",
            component: () => import("@/views/profile/invoice"),
          },
          { path: "auth", component: () => import("@/views/profile/auth") },
        ],
      },
    ],
  },
  {
    path: "/thirdParty/file",
    component: () => import("@/views/index/thirdParty/file"),
  },
  {
    path: "/report/view/online",
    component: () => import("@/views/index/report/view"),
  },
  {
    path: "/report/view/pdf",
    component: () => import("@/views/index/report/view/pdf"),
  },
  {
    path: "/login",
    meta: { auth: false },
    component: () => import("@/views/login"),
  },
  {
    path: "/login/wx/pf",
    meta: { auth: false },
    component: () => import("@/views/login/wx/pf"),
  },
  {
    path: "/login/wx/none",
    meta: { auth: false },
    component: () => import("@/views/login/wx/none"),
  },
  {
    path: "/forgot",
    meta: { auth: false },
    component: () => import("@/views/forgot"),
  },
  {
    path: "/registry",
    meta: { auth: false },
    component: () => import("@/views/registry"),
  },
  {
    path: "/registry/success",
    meta: { auth: false },
    component: () => import("@/views/registry/success"),
  },
  {
    path: "/first/guide",
    meta: { auth: false },
    component: () => import("@/views/login/firstguide"),
  },
  {
    path: "/error/500",
    meta: { auth: false },
    component: () => import("@/views/error/500"),
  },
  {
    path: "/test",
    meta: { auth: false },
    component: () => import("@/views/test"),
  },
  {
    path: "*",
    meta: { auth: false },
    component: () => import("@/views/error/404"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes: staticRoutes,
});

// 适配第三方跳转过来的路由
function adaptThirdParty(to) {
  const lu = to.query;
  const whiteList = ["manage", "ncc"];
  if (!whiteList.includes(lu.endType)) return;
  const expireSeconds = lu.expireSeconds ? lu.expireSeconds * 1000 : null;
  Vue.ls.set("token", lu.token, expireSeconds);
  store.commit("setToken", lu.token);
}

router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta && to.meta.auth === false) {
    next();
  } else {
    adaptThirdParty(to);
    let token = Vue.ls.get("token");
    if (token) {
      next();
    } else {
      next({ path: `/login?redirect=${to.fullPath}`, replace: true });
    }
  }
});

router.afterEach(async () => {
  await updateVersion();
  NProgress.done();
});

export default router;
